module.exports = __webpack_public_path__ + "static/img/case-page-bg-01.bfd2b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-page-bg-01.png
// module id = 4Brm
// module chunks = 1